import React from "react";
import { HOME } from "@/constants/testIds";

const LOGO_URL = "/brand/logo.jpg";

export const Header = ({ onHome, onAbout, currentPath = "" }) => {
  const linkClass = (active) =>
    `text-sm font-medium tracking-tight transition-colors ${
      active
        ? "text-[#0E7C7B]"
        : "text-[#1F2E4D] hover:text-[#0E7C7B]"
    }`;

  return (
    <header className="sticky top-0 z-30 w-full bg-[#F6F1E8]/85 backdrop-blur-md border-b border-[#E8E2D4]">
      <div className="max-w-2xl mx-auto px-6 sm:px-8 h-[68px] flex items-center justify-between gap-4">
        <button
          type="button"
          onClick={onHome}
          data-testid={HOME.headerLogo}
          className="flex items-center gap-3 group min-w-0"
          aria-label="Go to Heart Reach Counselling Services home"
        >
          <span className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-white border border-[#E8E2D4] overflow-hidden shrink-0">
            <img
              src={LOGO_URL}
              alt="Heart Reach logo"
              loading="eager"
              decoding="async"
              className="w-11 h-11 object-cover"
            />
          </span>
          <span className="flex flex-col leading-tight text-left min-w-0">
            <span className="text-[12px] sm:text-sm tracking-[0.18em] uppercase font-extrabold text-[#1F2E4D] truncate">
              Heart Reach
            </span>
            <span className="font-serif text-[13px] sm:text-[15px] text-[#0E7C7B] -mt-0.5 truncate">
              Counselling Services
            </span>
          </span>
        </button>

        <nav className="flex items-center gap-4 sm:gap-6 shrink-0">
          <button
            type="button"
            onClick={onHome}
            data-testid="nav-sponsor-link"
            className={linkClass(currentPath === "/sponsor-a-relative")}
          >
            Sponsor
          </button>
          <button
            type="button"
            onClick={onAbout}
            data-testid="nav-about-link"
            className={linkClass(currentPath === "/about")}
          >
            About
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
